import howInterprateResult from "../../translations/pl_PL/blog/howInterprateResult.json";
import { PUT_DATA_BLOG } from '../Blog/action';

function howInterprateResultReducer(state = howInterprateResult, action) {
  switch (action.type) {
    case PUT_DATA_BLOG:
      {
        if (action.meta === "howInterprateResult") {
          return action.payload;
        } else { 
          return state }
      }

    default:
      return state;
  }
}

export default howInterprateResultReducer;
